import { render, staticRenderFns } from "./SignaturePad.vue?vue&type=template&id=15b95cc8&scoped=true"
import script from "./SignaturePad.vue?vue&type=script&lang=js"
export * from "./SignaturePad.vue?vue&type=script&lang=js"
import style0 from "./SignaturePad.vue?vue&type=style&index=0&id=15b95cc8&prod&scoped=true&lang=css"
import style1 from "./SignaturePad.vue?vue&type=style&index=1&id=15b95cc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b95cc8",
  null
  
)

export default component.exports